// eslint-disable-next-line no-restricted-imports
import { useBlockNoteEditor as useBlockNoteEditorFromReact } from "@blocknote/react";

import { type StotlesBlockNoteEditor, stotlesBlockNoteSchema } from "./types";

/**
 * BlockNote editor instance typed with the Stotles schema (default + custom blocks).
 * Use this in Stotles BlockNote UI instead of {@link useBlockNoteEditor}.
 */
export function useStotlesBlockNoteEditor(): StotlesBlockNoteEditor {
  return useBlockNoteEditorFromReact(stotlesBlockNoteSchema);
}
